import React from 'react'
import { connect } from 'react-redux'
import Tooltip from '@mui/material/Tooltip'

import request from '@/modules/base/util/request'
import bankingConfig from '../../../../modules/banking/config'
import lang from 'lang'
import { BankingPasswordInput } from '../inputs/index'
import { ModalSmall } from '../../../base/components/modal'
import { CancelButton, ButtonIconSquare } from '../../../base/components/buttons'
import Loader from '../../../base/components/loader/loader'
import styles from './pin-modal.css'

import IconCheck from 'assets/images/icons/check.svg'
import { BankingService } from '../../services'
import Checkbox from '../../../base/components/inputs/checkbox/checkbox'
import {
  openBankAccountSetupPin,
  closeBankAccountSetupPin,
  closeBankAccountSetupTanInput,
} from '@/redux/ducks/banking/bankAccountSetup'
import {
  fetchBankAccountList,
} from '@/redux/ducks/banking/bankAccountList'

import { toast } from '@/modules/base/components/toast/toastConfig'
import { getProcessIdHeader } from '@/modules/banking/_helpers/generateProcessId'

const { urls } = bankingConfig

class PinModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      pin: undefined,
      storePin: true,
      pinErrorMessage: null,
      useModal: true,
    }

    this.handleChange = this.handleChange.bind(this)
    this.onCancel = this.onCancel.bind(this)
    this.onConfirm = this.onConfirm.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onStorePinChanged = this.onStorePinChanged.bind(this)
  }

  componentWillUnmount() {
    this.setState({ pin: undefined, storePin: false, useModal: true })
  }

  componentDidMount() {
    if (
      this.props.bankAccountSetup
      && this.props.bankAccountSetup.showBankAccountSetupView
    ) {
      const { transaction: { providePinRequest: { token } } } = this.props
      this.props.openBankAccountSetupPin(token)
      this.setState({ useModal: false })
    }
  }

  componentDidUpdate() {
    if (!this.state.useModal && this.props.bankAccountSetup && this.props.bankAccountSetup.showBankAccountSetupView) {
      switch (true) {
        case !!this.props.bankAccountSetup.errorBankAccountSetupPin:
          const {
            onError,
          } = this.props
          onError(this.props.bankAccountSetup.errorBankAccountSetupPin)
          break
        case !!this.props.bankAccountSetup.abortBankAccountSetupPin:
          const {
            onAbort,
          } = this.props
          onAbort()
          break
        case this.props.bankAccountSetup.successBankAccountSetupPin:
          const {
            transaction,
            onSuccess,
          } = this.props
          onSuccess(transaction)
          this.props.closeBankAccountSetupTanInput()
          break
      }
    }
  }

  handleChange(name) {
    return (event) => {
      this.setState({ [name]: event.target.value })
    }
  }

  onConfirm() {
    const { pin, storePin } = this.state
    const {
      transaction,
      processId,
      onSuccess,
      onError,
      contextMenu,
    } = this.props
    const { providePinRequest: { token } } = transaction

    if (!pin) {
      return this.setState({ pinErrorMessage: lang.bankMissingPinErrorMessage })
    }

    return BankingService.psd2.callbacks.pin(token, { pin, storePin }, processId)
      .then(() => {
        this.setState({ loading: false }, () => {
          onSuccess(transaction)
        })
      })
      .catch(onError)
      .finally(() => {
        if (storePin && contextMenu && contextMenu.accountData && contextMenu.accountData.contactId) {
          const url = urls.autoSyncContact(contextMenu.accountData.contactId)
          request(url, { method: 'PUT', auth: true, data: { autoSyncBookings: true }, headers: { ...getProcessIdHeader(processId) } })
            .then(() => toast.showToast({ message: lang.bankingSetContactPinSuccessMessage }))
            .catch(() => {
              return toast.showToast({ type: 'error', message: lang.defaultErrorMessage })
            })
        }
        this.props.fetchBankAccountList()
      })
  }

  onStorePinChanged(value) {
    this.setState({ storePin: value })
  }

  onCancel() {
    const { onAbort } = this.props
    onAbort()
  }

  onSubmit(event) {
    event.preventDefault()
    this.onConfirm()
  }

  render() {
    const { loading, pinErrorMessage, storePin, useModal } = this.state

    const buttons = [
      <CancelButton
        key='cancel'
        type='cancel'
        label={lang.cancelButtonLabel}
        onClick={this.onCancel} />,
      <ButtonIconSquare
        key='confirm'
        customClass={styles.actionButton}
        type='submit'
        icon={IconCheck}
        label={lang.confirmButtonLabel}
        onClick={this.onConfirm} />,
    ]

    return (
      useModal
        ? <ModalSmall
          title='PIN-Abfrage'
          subtitle='Bitte Online-PIN eingeben'
          actions={buttons}
          disableEscapeKeyDown
          disableBackdropClick
          open={true}
          onClose={this.onModalClose}>
          <Loader customClass={styles.loader}
            text="Lädt..."
            visible={loading} />
          <form className={styles.form} onSubmit={this.onSubmit}>
            <BankingPasswordInput
              autoFocus
              name='pin'
              label='PIN'
              errorMessage={pinErrorMessage}
              showStrengthBar={false}
              onChange={this.handleChange('pin')} />
            <div className={styles.checkboxWrapper}>
              <Checkbox
                checked={storePin}
                name='safePin'
                customClass={styles.checkbox}
                onChange={this.onStorePinChanged}>
                <span className={styles.checkboxLabel}>PIN speichern</span>
              </Checkbox>
              <Tooltip classes={{ tooltip: styles.tooltip }} title={lang.bankingAutobankingInfo}>
                <div className={styles.infoWrapper}>i</div>
              </Tooltip>
            </div>
          </form>
        </ModalSmall>
        : null
    )
  }
}

const mapStateToProps = (state) => {
  const {
    banking: {
      bankAccountList: { selectedBankAccount, contextMenu },
      bankAccountSetup,
    },
  } = state

  return {
    selectedBankAccount,
    contextMenu,
    bankAccountSetup,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    openBankAccountSetupPin: (token) => dispatch(openBankAccountSetupPin(token)),
    closeBankAccountSetupPin: () => dispatch(closeBankAccountSetupPin()),
    closeBankAccountSetupTanInput: () => dispatch(closeBankAccountSetupTanInput()),
    fetchBankAccountList: () => dispatch(fetchBankAccountList()),
  }
}

PinModal.defaultProps = {
  open: false,
  trialExpired: false,
}

export default connect(mapStateToProps, mapDispatchToProps)(PinModal)
